// src/pages/Courses/CoursesPage.tsx
import React from 'react';
import CourseList from '../../components/Course/CourseList';
import StudentCourseList from '../../components/Course/StudentCourseList';
import { Button, Box, Container, Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../components/AuthContext';
import { UserRole } from '../../common/enums';
import AuthoringAssistantPanel from '../../components/AI/AuthoringAssistantPanel';
import { buildAuthoringAssistantCreateState } from '../../components/AI/authoringAssistantNavigation';

const CoursesPage: React.FC = () => {
  const { user } = useAuth();
  const isStudent = user?.role === UserRole.Student;
  const canUseAuthoringAssistant = user?.role === UserRole.Admin || user?.role === UserRole.Tutor;
  const navigate = useNavigate();

  return (
    <Container maxWidth={false} disableGutters>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 3,
          flexDirection: { xs: 'column', xl: 'row' },
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0, width: '100%' }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Kurssit
          </Typography>

          {!isStudent && (
            <Box display="flex" justifyContent="space-between" alignItems="center" my={2}>
              <Button variant="contained" color="primary" component={Link} to="/course/create">
                Luo uusi kurssi
              </Button>
            </Box>
          )}

          {isStudent ? <StudentCourseList /> : <CourseList />}
        </Box>

        {canUseAuthoringAssistant && (
          <AuthoringAssistantPanel
            createActions={[
              {
                id: 'create-course',
                label: 'Aloita uusi kurssi',
                onCreate: (prompt) => {
                  navigate('/course/create', {
                    state: buildAuthoringAssistantCreateState('course', prompt),
                  });
                },
              },
            ]}
          />
        )}
      </Box>
    </Container>
  );
};

export default CoursesPage;
